export const GITHUB_URL = 'https://github.com/yassinehanafi3';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/elhanafiyassine/';
